<template>
  <div class="two-phone-qrcode-container">
    <div class="logo-container">
      <img src="https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/introduction/logo.png" alt="" class="logo" />
    </div>
    <div class="ab-container">
      <div class="tip-text">
        <p>邀请好友扫码加入</p>
        <p>将好友手机放在右侧</p>
      </div>

      <div class="qr-container">
        <div class="canvas-container">
          <canvas ref="canvas"></canvas>
        </div>
      </div>

      <div class="alone-container">
        <p>没人陪我看</p>
        <p>……</p>
      </div>

      <div class="bt" @click="goAlone">进入单机模式</div>
    </div>
  </div>
</template>

<script>
// 扫码 --- 主机
function guid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
import QRCode from "qrcode";
export default {
  data() {
    return {
      websock: null,
      uuid: "",
      reTryTimer: 0,
    };
  },
  mounted() {
    this.uuid = guid();
    this.drawQr();
    this.initWebSocket();
  },
  beforeDestroy() {
    clearTimeout(this.reTryTimer);
    this.websock.close();
  },
  methods: {
    goAlone() {
      this.$router.replace(
        `/view-video/${this.$route.params.where}/mid/${this.uuid}`
      );
    },
    drawQr() {
      let canvas = this.$refs.canvas;
      canvas.height = canvas.offsetHeight;
      canvas.width = canvas.offsetWidth;
      QRCode.toCanvas(
        canvas,
        `${location.origin}/lh/#/two-phone-scan-code/${this.$route.params.where}/${this.uuid}`,
        {
          width: canvas.width,
          height: canvas.height,
          margin: 1,
        }
      );
    },

    initWebSocket() {
      //初始化weosocket
      const wsuri = `ws://jshare.xhby.net/lianghui/ws/${this.uuid}`;
      this.websock = new WebSocket(wsuri);
      this.websock.onmessage = (msg) => {
        switch (msg.data) {
          case "1":
            // alert("test: 我是主机,链接成功");
            break;
          case "2":
            // alert("副机链接上了");
            this.$router.replace(
              `/view-video/${this.$route.params.where}/left/${this.uuid}`
            );
            break;
        }
      };
      this.websock.onopen = (e) => {
        // console.log("opened", e);
      };
      this.websock.onerror = (e) => {
        console.error("webSocketError", e);
        this.reTryTimer = setTimeout(this.initWebSocket, 2000);
      };
      // this.websock.onclose = this.websocketclose;
    },
  },
};
</script>

<style scoped>
.two-phone-qrcode-container {
  position: relative;
}

.logo-container {
}

.logo {
  margin-right: 4vw;
  margin-left: auto;
  display: block;
  width: 20vw;
}

.ab-container {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.tip-text {
  font-size: 18px;
  color: #ffde98;
  line-height: 26px;
  text-align: center;
}

.qr-container {
  margin-top: 18px;
}

.canvas-container {
  width: 30vw;
  height: 30vw;
  /* background: white; */
}

canvas {
  width: 100%;
  height: 100%;
}

.alone-container {
  margin-top: 60px;
  font-size: 18px;
  color: #ffde98;
  line-height: 26px;
  text-align: center;
}

.bt {
  width: 130px;
  height: 32px;
  background: #ffde98;
  border-radius: 16px;
  line-height: 32px;

  font-size: 16px;
  color: #990100;
  line-height: 32px;
  text-align: center;
  margin-top: 20px;
}
</style>